import { render, staticRenderFns } from "./extension-record-list.vue?vue&type=template&id=2cdaebf2"
import script from "./extension-record-list.vue?vue&type=script&lang=js"
export * from "./extension-record-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports